<div class="container py-5">
  <div class="row align-items-center">
    <div class="col-md-6 text-center text-md-start">
      <h1 class="fw-bold mb-3">Liderando la Educación en Protección Radiológica</h1>
      <p class="lead text-muted mb-4">
        Su Licencia de Operador al alcance de un clic.
      </p>
      <button matButton="filled" color="accent" (click)="actionVerMas()">
        Ver Más
      </button>
    </div>
    <div class="col-md-6 text-center">
      <img src="assets/images/inicio.svg" alt="Ilustración médica" class="img-fluid" />
    </div>
  </div>
</div>
